import fishCatalogue from "../catalogues/Atman Aquarium Product Catalogue.pdf";
import birdCageCatalogue from "../catalogues/Cage Product Catalogue.pdf";
import bigLogo from "../image/atman_logo.png";
import React from "react";
import ReactLoading from "react-loading"
import {useHistory} from "react-router-dom";


const OpenCatalogue = (props) => {
    const {
        file
    } = props;

    const history = useHistory();

    if (file === FILE_FISH) {
        window.open(fishCatalogue, "_self", "noopener");
    }
    else if (file === FILE_CAGE) {
        window.open(birdCageCatalogue, "_self", "noopener");
    }
    else {
        history.push("/catalogue");
    }

    return (
        <div className={"m-2 pt-5"}>
            <div className={"container w-50"}>
                <div className={"mx-auto text-center"}>
                    <img alt="Atman Logo" src={bigLogo} className="imageLogo-l" style={{
                        "filter": "brightness(1.5)",
                    }}/>

                    <ReactLoading type={"bubbles"} color={"rgb(185,185,185)"} height={'15%'} width={'15%'} className={"mx-auto"} />
                </div>
            </div>
        </div>
    )
};

export const FILE_FISH = "fish";
export const FILE_CAGE = "cage";

export default OpenCatalogue;
